// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'
import http from 'vue-resource'
import plVeeValidate from 'vee-validate/dist/locale/pl'
// , { Validator }
import VeeValidate from 'vee-validate'
import { default as I18n, tr } from './plugins/i18n'
import Helper from './plugins/helper'
import Dropdown from './components/reusable/dropdown'
import Radio from './components/reusable/radio'
import Paginator from './components/reusable/paginator'

Vue.config.productionTip = false

const veeValidateConfig = {
  errorBagName: 'errors', // change if property conflicts.
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'pl',
  dictionary: {
    plVeeValidate
  },
  strict: true,
  classes: false,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'blur',
  inject: true,
  validity: true,
  aria: true
}

router.beforeEach((to, from, next) => {
  if (!store.getters.logged) {
    if (to.name === 'Login') {
      next()
    } else {
      router.push({name: 'Login'})
    }
  } else {
    next()
  }
})

Vue.use(http)
Vue.http.interceptor.before = function (req, next) {
  if (store.getters.getToken !== null) {
    req.headers.set('X-AUTH-TOKEN', store.getters.getToken)
  }
  next((response) => {
    if (response.status === 403 && router.currentRoute.name !== 'Login') {
      router.push({name: 'Login'})
      this.$alertify.notify(tr('Wymagane ponowne zalogowanie', 'General'), 'error', 3)
    }
    // token refresh
    // if (typeof response.headers !== 'undefined' && typeof response.headers.map !== 'undefined' && typeof response.headers.map['x-auth-token'] !== 'undefined') {
    //   store.commit('REFRESH_TOKEN', response.headers.map['x-auth-token'][0])
    // }
  })
}

// Validator.localize(plVeeValidate)
Vue.use(VeeValidate, veeValidateConfig)
Vue.use(I18n)
Vue.use(Helper)

// reusable components
Vue.use(Dropdown)
Vue.use(Radio)
Vue.use(Paginator)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js